import { NEW_JEWELRY_BOX_PENDING, CREATE_JEWELRY_BOX_PENDING, GET_JEWELRY_BOX_USER_DATA } from 'actions/pendingJewelryBox';
// if (!!action.error) {
export default (state = null, action) => {
    switch (action.type) {
        case NEW_JEWELRY_BOX_PENDING:
            return action.payload;
        case CREATE_JEWELRY_BOX_PENDING:
            return action.payload.data;
        case GET_JEWELRY_BOX_USER_DATA:
            return action.payload.data;
    }
    return state;
}
